import * as gridService from '../services/gridService';
import * as concurrencyCompanyService from '../services/concurrencyCompanyService';
import { getLogger } from '../commons/logger';
import type { TestPlayer } from './BaseWorker';

const logger = getLogger('worker-utils');

const releaseGridSlot = async (workerId: number, releaseSlotOnTestFinished: boolean, projectId: string) => {
    if (!releaseSlotOnTestFinished) {
        return;
    }
    await gridService.releaseGridSlot(workerId, projectId);
};


const releaseCompanySlot = async (workerId: number, companyId: string, projectId: string) => {
    await concurrencyCompanyService.releaseCompanySlot(workerId, companyId, projectId);
};

export const releasePlayer = async (workerId: number, releaseSlotOnTestFinished: boolean, projectId: string, companyId: string, slotService: 'mongo' | 'redis', player?: TestPlayer) => {
    logger.info('releasing player', { hasPlayer: Boolean(player) });
    try {
        await player?.onDone();
    } finally {
        if (slotService === 'mongo') {
            await releaseGridSlot(workerId, releaseSlotOnTestFinished, projectId);
        }
        if (slotService === 'redis') {
            await releaseCompanySlot(workerId, companyId, projectId);
        }
    }
};
